import React from 'react';
import PropTypes from 'prop-types';

export default function ImageDrawCard({ title, thumb, image, onClick }) {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick(title, image);
        }
    };

    return (
        <div className="col">
            <div
                className="eye-draw-card h-100"
                role="button"
                tabIndex={0}
                onClick={() => onClick(title, image)}
                onKeyDown={handleKeyDown}
                aria-label={`Open ${title} for drawing`}
            >
                <div className="eye-draw-card__media">
                    <img src={thumb} alt={title} loading="lazy" />
                    <div className="eye-draw-card__overlay">
                        <i className="bi bi-pencil-square"></i>
                        <span className="btn btn-sm btn-accent px-3">Draw</span>
                    </div>
                </div>
                <div className="eye-draw-card__footer">
                    <span className="eye-draw-card__title">{title}</span>
                </div>
            </div>
        </div>
    );
}

ImageDrawCard.propTypes = {
    title: PropTypes.string.isRequired,
    thumb: PropTypes.string.isRequired,
    image: PropTypes.any.isRequired,
    onClick: PropTypes.func.isRequired,
};
